import { Field, Int, ObjectType } from '@nestjs/graphql'
import { ArcDto } from './model.dto'

@ObjectType()
export class ArcWithStatsDto extends ArcDto {
  @Field(t => Int)
  daysLeft!: number

  @Field(t => Int)
  totalClaims!: number
}
